<div class="flex h-dvh flex-col bg-(--surface-muted) text-(--text-default)" [dir]="direction()">
  <app-header
    [appName]="appNameKey"
    [logoUrl]="logoUrl"
    [userName]="userLogged.name"
    [roleName]="roleName"
    [personNumber]="userLogged.personNumber"
    (menuClick)="toggleSidebar()"
    (logoutClick)="logout()" />

  <mat-sidenav-container class="shell-container flex-1" [dir]="direction()">
    <mat-sidenav
      #sidenav
      [mode]="isMobile() ? 'over' : 'side'"
      [opened]="!isMobile()"
      [fixedInViewport]="isMobile()"
      [autoFocus]="isMobile()"
      [style.width.px]="isMobile() ? 260 : 254"
      class="border-r border-(--border-subtle) bg-(--surface)">
      <app-sidebar
        [menuItems]="menuItems()"
        (itemSelected)="closeSidebarOnMobile()"
        (logoutClick)="logout()" />
    </mat-sidenav>

    <mat-sidenav-content class="bg-(--surface-muted) h-full overflow-y-auto">
      <main class="min-h-[calc(100dvh-4rem)] p-4 sm:p-5 lg:p-6">
        <div class="mx-auto w-full max-w-400">
          <router-outlet />
        </div>
      </main>
    </mat-sidenav-content>
  </mat-sidenav-container>
</div>
